<template>
	<el-table :data="message"
		style="width: 100%"
		:show-header="false"
		row-key="id"
		@row-click="selectRow"
		:expand-row-keys="expand"
		:empty-text="empty"
		:cell-style="{ 'vertical-align': 'top' }">

		<el-table-column
			prop="time"
			width="150">
			<template slot-scope="scope">
				<DateTime :time="scope.row.time"></DateTime>
			</template>
		</el-table-column>
		<el-table-column>
			<template slot-scope="scope">
				<MessagePreview :row="scope.row" :body="body"></MessagePreview>
			</template>
		</el-table-column>
		<el-table-column
			prop="status"
			label="Status"
			width="100">
			<template slot-scope="scope">
				<MessageStatus :row="scope.row"></MessageStatus>
			</template>
		</el-table-column>
	</el-table>
</template>

<script>
import CardTable from '../component/table'

export default {
	name: 'patient-message-card-table',
	extends: CardTable,

	props: {
		message: {
			type: Array,
			required: true
		},
		empty: {
			type: String,
			default: 'No messages'
		},
		body: {
			type: Boolean,
			default: true
		}
	}
}
</script>
